module.exports = __webpack_public_path__ + "static/img/o9m3.5870243.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/works/o9m/o9m3.jpg
// module id = KBlF
// module chunks = 1